import type { AvailableAxiosInstances } from "utils/request"

/**
 * Central registry mapping each service domain to its axios instance.
 * To migrate a domain to a different backend, change one line here.
 *
 * Instances:
 *   newArchAxiosInstance — corebackend-dev (Bearer auth)
 *   ewaAxiosInstance     — EWA / customization backend (access_token auth, REACT_APP_EWA_BASE_URL)
 *   walletAxiosInstance  — Wallet backend (access_token + api_key auth)
 *   newArchAxiosInstance        — Legacy backend (access_token auth) — pending migration to newArch
 */
export const SERVICE_INSTANCES = {
  auth: "newArchAxiosInstance",
  onboarding: "newArchAxiosInstance",
  employee: "newArchAxiosInstance",
  adminPeople: "newArchAxiosInstance",
  manager: "newArchAxiosInstance",
  contractors: "newArchAxiosInstance",
  benefits: "newArchAxiosInstance",
  payroll: "newArchAxiosInstance",
  timeAttendance: "ewaAxiosInstance",
  paymentSchedules: "newArchAxiosInstance",
  ats: "newArchAxiosInstance",
  approvalWorkflow: "newArchAxiosInstance",

  // ── EWA / customization backend ────────────────────────────────────────────
  // NOTE: customizationSettingsBaserUrl === REACT_APP_EWA_BASE_URL === ewaAxiosInstance base URL
  // Files that called newArchAxiosInstance with this URL were hitting the right server
  // but with the wrong auth header (access_token vs expected). Use ewaAxiosInstance.
  oauthSettings: "ewaAxiosInstance",
  integrations: "ewaAxiosInstance",
  loans: "ewaAxiosInstance",
  ewa: "ewaAxiosInstance",
  files: "ewaAxiosInstance",
  wallet: "walletAxiosInstance",
  employeeWallet: "newArchAxiosInstance",
  audit: "newArchAxiosInstance",
  company: "newArchAxiosInstance",
  customFields: "newArchAxiosInstance",
  performance: "newArchAxiosInstance",
  requests: "newArchAxiosInstance",
  assets: "newArchAxiosInstance",
  announcements: "newArchAxiosInstance",
  documents: "newArchAxiosInstance",
  surveys: "newArchAxiosInstance",
  common: "newArchAxiosInstance",
  disciplinary: "newArchAxiosInstance",
  dashboard: "newArchAxiosInstance",
  tasks: "newArchAxiosInstance",
  timeTracking: "newArchAxiosInstance",
  reports: "newArchAxiosInstance",
  adminWallet: "newArchAxiosInstance",
  roles: "newArchAxiosInstance",
  approvalWorkflows: "newArchAxiosInstance",
  customNotifications: "newArchAxiosInstance",
  payslip: "newArchAxiosInstance",
} as const satisfies Record<string, AvailableAxiosInstances>

export type ServiceName = keyof typeof SERVICE_INSTANCES
